<script lang="ts">
  import clsx from 'clsx';

  const { sizeClass = 'w-full h-full' }: { sizeClass?: string } = $props();
</script>

<svg
  xmlns="http://www.w3.org/2000/svg"
  class={clsx(sizeClass, 'overflow-hidden align-middle')}
  viewBox="0 0 156.69 179.12"
>
  <defs>
    <style>
      .cheese-1 {
        fill: #fada39;
      }
      .cheese-2 {
        fill: #e8b221;
      }
      .cheese-3 {
        fill: #2e2b22;
      }
    </style>
  </defs>
  <g id="Layer_1-2">
    <g>
      <path
        class="cheese-3"
        d="M0,73.63C41.95,48.89,82.91,24.73,124.84,0c10.5,15.93,21.99,31,30.57,47.58,3.12,6.03-.33,15.69-1.38,23.61-4.28,32.53-9.57,71.92-14.19,105.94-.2,1.45-1.68,2.35-3.06,1.85-27.3-9.88-55.32-22.01-81.21-31.36-12.33-4.45-31.15-14.73-32.95-18.8-4.82-10.94-10.41-23.52-15.17-35.71-2.44-6.25-4.8-12.53-7.45-19.48Zm43.84,31.16c34.26-18.34,68.56-36.04,104.07-55.05-10.57-13.08-20.03-24.76-29.63-36.65-32.41,19.19-63.97,37.87-95.52,56.55l1.01,2.05c12.63-5.05,25.26-10.09,37.89-15.14l.79,1.47c-11.61,8.09-23.22,16.17-34.83,24.26-1.07,.46-2.14,.91-3.22,1.37l.32,1.11,4.34-.65,30.18-9.79,.84,1.76c-10.37,6.74-20.75,13.48-31.12,20.21l.66,1.5c8.68-2.23,17.35-4.46,26.03-6.69l.73,1.44c-4.14,3.38-7.06,7.31-11.2,10.69-1.06,.43-2.23,.7-3.29,1.13l-.08,.57c1.3,.58,.75-.75,2.05-.17Zm103.11-39.58l-3.27-2.24c-34.51,19.64-69.01,39.27-105.28,59.91,32.2,14.15,62.23,27.34,93.91,41.27,5.15-34.8,9.89-66.87,14.63-98.94Z"
      />
      <path
        class="cheese-1"
        d="M146.95,65.2c-4.74,32.07-9.49,64.14-14.63,98.94-31.69-13.92-61.72-27.12-93.91-41.27,36.28-20.65,70.81-40.29,105.33-59.94,1.07,.76,2.15,1.51,3.22,2.27Z"
      />
      <path
        class="cheese-2"
        d="M27.6,82.29c11.58-8.06,23.15-16.12,34.73-24.18-.23-.52-.46-1.03-.69-1.55-12.68,5.06-25.35,10.13-38.03,15.19-.29-.7-.58-1.4-.87-2.1,31.56-18.68,63.11-37.36,95.52-56.55,9.61,11.88,19.06,23.57,29.63,36.65-35.02,18.75-68.81,36.83-102.6,54.92-.46-.65-.92-1.3-1.38-1.95l12.29-10.02c-.2-.52-.39-1.04-.59-1.56-8.68,2.23-17.35,4.46-26.03,6.69-.18-.52-.37-1.04-.55-1.57,10.32-6.7,20.64-13.4,30.96-20.11-.26-.6-.52-1.2-.78-1.8-10.06,3.26-20.12,6.52-30.18,9.79-.48-.61-.96-1.22-1.44-1.83Z"
      />
      <path
        class="cheese-2"
        d="M29.05,84.12l-4.34,.65c-.1-.37-.19-.75-.29-1.12,1.06-.45,2.13-.91,3.19-1.36,.48,.61,.96,1.22,1.44,1.83Z"
      />
      <path
        class="cheese-2"
        d="M45.31,104.66c-1.42,.18-6.92,2.63-8.34,2.81-.1-.4,3.98-2.66,3.88-3.06,1.06-.43,2.02-1.27,3.07-1.7,.46,.65,.92,1.3,1.38,1.95Z"
      />
    </g>
  </g>
</svg>
